/** @module Sourcing/MassAdoptSupplierItemsAsStylesForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/def",
	"csi/def/Field",
	"csi/image/_base",
	"csi/locale",
	"csi/reflection",
	"csi/widget/LabeledImage",
	"csi/xml",
	"./AdoptSupplierItemToStyleForm"

], function(declare, lang, _, def, Field, csiImage, locale, reflection, RightWidgetImage, xml, AdoptSupplierItemToStyleForm) {

	var INSPIRATION_STYLE = "InspirationStyle";
	var SUPPLIER = "Supplier";
	var SUPPLIER_ITEM = "SupplierItem";

	// Path from this SupplierItem to the Supplier
	var PATH_SUPPLIER = "Child:__Parent__/Child:Supplier";

	// Path from this SupplierItem to the SRLineItem
	var PATH_SRLINEITEM = "Child:QuoteSRLineItem";

	return declare([AdoptSupplierItemToStyleForm], {

		/**
		 * On Mass Adopt form, pre-fill the Style name field as the Inspiration Style's name instead of the Quote's name
		 */
		getValueForField: function(field, node) {
			if (field.m_id == xml.ATTR_NAME) {
				return this.getDefaultValue(field.getControlName());
			}

			return this.inherited(arguments);
		},

		/**
		 * Set fields' fixed values and add image with label
		 */
		_buildView: function() {
			this._supplierItem = this._supplierItem || this.getViewNode();

			if (!_.isEmpty(this._supplierItem?.Images)) {
				this.rightWidgetClass = RightWidgetImage;
				this.rightWidgetProperties = {
					imageLabel: locale.resource("Supplier Quote Image"),
					imageSrc: csiImage.getImageSrc(this._supplierItem, null, reflection.ATTR_MEDIUM_IMAGE)
				};
			}

			this.addFixedValue(SUPPLIER_ITEM, this._supplierItem.$Name);

			var srLineItem = this._getSRLineItem();
			if (srLineItem) {
				this.addFixedValue(INSPIRATION_STYLE, srLineItem.$Name);
			}

			var supplier = this.cacheView.getPathNode(this._supplierItem, PATH_SUPPLIER);
			this.addFixedValue(SUPPLIER, supplier.$Name);

			this.inherited(arguments);
		},

		_getRootRequest: function(node) {
			var req = this.inherited(arguments);
			req.addDependencyPaths([PATH_SUPPLIER, PATH_SRLINEITEM]);
			return req;
		},

		/**
		 * Add fields to the top of the mass adopt form
		 */
		_resolveView: function() {
			this.inherited(arguments);

			this.insertField(lang.mixin(new Field(), {
				m_label: SUPPLIER,
				m_typeControl: def.FIELD_TEXT
			}), 0, true);

			this.insertField(lang.mixin(new Field(), {
				m_label: SUPPLIER_ITEM,
				m_typeControl: def.FIELD_TEXT
			}), 0, true);

			this.insertField(lang.mixin(new Field(), {
				m_label: INSPIRATION_STYLE,
				m_typeControl: def.FIELD_TEXT
			}), 0, true);
		}

	});
});